import Head from "view/components/Head";
import { PageHeadingProps } from "../../types";

const PageHeading = ({ }: PageHeadingProps) => {
  return (
    <div className="flex flex-col justify-start items-start flex-grow py-0.5">
      <Head title="Imports: Add Import" />
      <div className="relative flex items-center self-stretch justify-start flex-grow-0 flex-shrink-0">
        <p className="flex-grow  text-[28px] font-bold text-left text-textMid capitalize dark:text-textMain">
          Import data from a file
        </p>
      </div>
    </div>
  );
};

export { PageHeading };
